import {
    type SidebarSection,
    useMenu,
    useWalkthroughStore,
} from '@core-ui/components';
import { useScreenInfo } from '@moniebook-web/components/shared/hooks';
import { Sidebar as AppSidebar } from '@moniebook-web/components/widgets/sidebar';
import { useFeatureFlagStore } from '@moniebook-web/store';
import { MENU_SECTIONS } from '@moniebook-web/types';

import { MenusLoadingSkeleton } from './menus-skeleton/menus-skeleton';
import { UserDropdown } from './user-dropdown';

const SECTIONS: Array<SidebarSection> = [
    {
        id: MENU_SECTIONS.NONE,
    },
    {
        id: MENU_SECTIONS.SELLING,
        name: 'Selling',
    },
    {
        id: MENU_SECTIONS.INVENTORY,
        name: 'Inventory',
    },
    {
        id: MENU_SECTIONS.SALES_CHANNELS,
        name: 'Sales channels',
    },
] as const;

export function Sidebar() {
    const { featureFlags } = useFeatureFlagStore();
    const sections = useMenu(SECTIONS, featureFlags ?? {});
    const { triggerWalkthrough } = useWalkthroughStore();
    const { isMobile } = useScreenInfo();

    const expandAllMenu = triggerWalkthrough && !isMobile;

    return (
        <>
            {sections.length === 0 ? (
                <MenusLoadingSkeleton />
            ) : (
                <AppSidebar
                    prepend={<UserDropdown />}
                    sections={sections}
                    expandAllMenu={expandAllMenu}
                    key={`${expandAllMenu}`}
                />
            )}
        </>
    );
}
